import isPropValid from '@emotion/is-prop-valid';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useMemo, useRef } from 'react';
import { useTimeoutFn } from 'react-use';
import { StyleSheetManager } from 'styled-components';
import { Redirect, Router } from 'wouter';
import { uuid } from '../CodesThatsGottaGoSomewhereElse';
import { AppEvents } from './AppEvents';
import { AppLoading } from './AppLoading';
import { SetTitleUsingAppLocation } from './AppLocation';
import { NavigatorSupport } from './AppNavigator';
import { AppScope } from './AppScope';
import { AppSwitch } from './AppSwitch';
import { useResolve } from './Container';
import { DevelopmentInfo } from './DevelopmentInfo';
import { NavigationScope } from './account/navigation/NavigationScope';

const AppTriggerReady = () => {
    const events = useResolve(AppEvents);
    useTimeoutFn(() => events.push('ready', {}), 1000);
    return null;
};

export const App = () => {

    const queryClient = useMemo(() =>
        new QueryClient({
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                }
            }
        })
        , []);
    const key = useRef<string>(uuid());

    if (location.search === '?reload=true') {
        key.current = uuid();
        return <Redirect to={location.pathname} />;
    }

    // The order of these components does matter.
    return <StyleSheetManager shouldForwardProp={isPropValid}>
        <Router>
            <AppScope key={key.current} loader={AppLoading}>
                <QueryClientProvider client={queryClient}>
                    <NavigationScope>
                        <NavigatorSupport />
                        <AppSwitch />
                        <DevelopmentInfo />
                        {/* <HelpSupport /> */}
                        <AppTriggerReady />
                        <SetTitleUsingAppLocation />
                    </NavigationScope>
                </QueryClientProvider>
            </AppScope>
        </Router>
    </StyleSheetManager>;
};
